import { getAccessToken } from '../authentication/supabaseService';

const API_BASE = '/api/admin';

// ── Types (mirror server/database/aiCostsDbService.ts) ──
// Cost values are provider list-price magnitudes (nominally USD); displayed with € like
// the rest of the app. No conversion.

export interface AiCostTotals {
  cost: number;
  calls: number;
  inputTokens: number;
  outputTokens: number;
}

export interface AiCostByFeature {
  feature: string;
  cost: number;
  calls: number;
  inputTokens: number;
  outputTokens: number;
  models: string[];
}

export interface AiCostByModel {
  model: string;
  cost: number;
  calls: number;
  inputTokens: number;
  outputTokens: number;
}

export interface AiCostByRestaurant {
  /** restaurants uuid; null → spend that could not be attributed to a restaurant. */
  restaurantId: string | null;
  name: string | null;
  cost: number;
  calls: number;
}

export interface AiCostByDay {
  date: string;
  cost: number;
  calls: number;
}

export interface AiCostsResponse {
  month: string;
  totals: AiCostTotals;
  byFeature: AiCostByFeature[];
  byModel: AiCostByModel[];
  byRestaurant: AiCostByRestaurant[];
  byDay: AiCostByDay[];
}

async function fetchWithAuth(endpoint: string, options: RequestInit = {}) {
  const token = await getAccessToken();
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}: ${response.statusText}`);
  }

  return response.json();
}

/** Universal AI cost rollup for one month (`YYYY-MM`). */
export async function getAiCosts(month: string): Promise<AiCostsResponse> {
  return fetchWithAuth(`/ai-costs?month=${encodeURIComponent(month)}`);
}
